import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Notification from '../../../assets/images/Notification.png'
import offer from '../../../assets/images/offer.png'
import promotion from '../../../assets/images/promotion.png'
import { AppStyles } from '../../../assets/styles/AppStyles'
import Spinner from '../../../components/Spinner'
import SpinnerLarge from '../../../components/SpinnerLarge'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import AgreeToTerms from '../../../components/cards/AgreeToTerms'
import { getMarketingData } from '../../../redux/Actions/getMethods'
import { updateMarketingData } from '../../../redux/Actions/postMethods'
import { useTheme } from '../../../utils/ThemeColorContext'
import CheckInformationWrapper from '../CheckInformationWrapper'
import DefaultPage from '../DefaultPage'

function Marketing() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { marketingData, loadingWholeScreen } = useSelector(
    (state) => state.dataReducer,
  )
  const { loading, loading2 } = useSelector((state) => state.authReducer)
  const { color, isSmallScreen } = useTheme()
  const [promotions, setPromotion] = useState(true)
  const [partnerOffer, setPartnerOffer] = useState(false)

  useEffect(() => {
    dispatch(getMarketingData())
    if (marketingData?.status === 200) {
      setPartnerOffer(marketingData?.data[1]?.granted || marketingData?.data[1]?.permission?.enabled_by_default)
    } else if (!promotions) {
      setPromotion(marketingData?.data[0]?.granted || marketingData?.data[0]?.permission?.enabled_by_default)
    }
    if (Array.isArray(marketingData?.data) 
      && marketingData.data.length >= 2 
      && (marketingData?.data[0]?.granted === true 
      || marketingData?.data[1]?.granted === true)
    ) {
      navigate('/address-detail')
    }
  }, [marketingData?.status === 200])

  const addPermissions = async () => {
    const success = await dispatch(
      updateMarketingData(marketingData?.data, partnerOffer, promotions),
    )
    if (success) {
      //navigate('/manageloan')
      navigate('/address-detail')
    }
  }

  return (
    <DefaultPage>
      { (loadingWholeScreen || loading || loading2) ? (
        <SpinnerLarge />
      ) : (
        <div className="md:min-h-[800px] min-h-[600px] flex flex-col items-center justify-center ">
          <div className="relative container mx-auto md:w-6/12 space-y-10 p-6 ">
            <div className="h-full flex flex-col items-center justify-center space-y-10 ">
              <CheckInformationWrapper>
                <div className="w-full space-y-10">
                  <div className="flex flex-col items-center space-y-6">
                    <img src={Notification} className="w-[56px] h-[56px]" />
                    <h1
                      style={
                        isSmallScreen
                          ? {
                              ...AppStyles.Title1,
                              color: color.Plum,
                              width: '279px',
                            }
                          : {
                              ...AppStyles.Title1,
                              color: color.Plum,
                            }
                      }
                      className=" text-center"
                    >
                      Get the best from Updraft
                    </h1>
                    <p
                      style={
                        isSmallScreen
                          ? {
                              ...AppStyles.Body,
                              color: color.Grey,
                              margin: 0,
                              marginTop: '16px',
                            }
                          : {
                              fontSize: '16px',
                              fontWeight: '500',
                              lineHeight: '28px',
                              marginTop: '24px',
                              color: '#6C819C',
                              fontFamily: 'MaisonMedium","sans-serif',
                            }
                      }
                      className="leading-[24px] text-center md:w-[360px] w-full"
                    >
                      We’d love to keep you updated on new features & offers.
                      We’ll only ever nudge you when we need to & you can opt
                      out anytime.
                    </p>
                    {!loading && !loading2 ? (
                      <>
                        <div className="space-y-2 md:w-[360px] w-full">
                          { (Array.isArray(marketingData?.data) && marketingData.data.length >= 2 && marketingData?.data[0]?.granted !== true) && (
                            <AgreeToTerms
                              setIsOn={setPromotion}
                              isOn={promotions}
                              title={
                                marketingData?.data &&
                                marketingData?.data[0]?.permission?.description
                              }
                              customHeight={'80px'}
                              icon={promotion}
                            />
                          )}
                          { (Array.isArray(marketingData?.data) && marketingData.data.length >= 2 &&  marketingData?.data[1]?.granted !== true) && (
                            <AgreeToTerms
                              setIsOn={setPartnerOffer}
                              isOn={partnerOffer}
                              title={
                                marketingData?.data &&
                                marketingData?.data[1]?.permission?.description
                              }
                              doAuto={true}
                              icon={offer}
                              customHeight={'56px'}
                            />
                          )}
                        </div>
                        <PrimaryButton
                          id={'marketing-confirm-btn'}
                          text={loading ? <Spinner /> : 'Confirm'}
                          className={' w-full'}
                          onClick={() => {
                            if (loading) {
                              return
                            }
                            addPermissions()
                          }}
                        />
                      </>
                    ) : (
                      <Spinner />
                    )}
                  </div>
                </div>
              </CheckInformationWrapper>
            </div>
          </div>
        </div>
      )}
      {/* <Footer /> */}
    </DefaultPage>
  )
}
export default Marketing
